import { render, staticRenderFns } from "./SolutionHistoryGrid.vue?vue&type=template&id=c635820a&scoped=true&"
import script from "./SolutionHistoryGrid.vue?vue&type=script&lang=ts&"
export * from "./SolutionHistoryGrid.vue?vue&type=script&lang=ts&"
import style0 from "./SolutionHistoryGrid.vue?vue&type=style&index=0&id=c635820a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c635820a",
  null
  
)

export default component.exports